import categoryIcons from '../Utils/categoryIcons';

function hexToRgba(hex, alpha) {
  const h = String(hex || '#8e8e93').replace('#', '');
  if (h.length < 6) return `rgba(142, 142, 147, ${alpha})`;
  const r = parseInt(h.substring(0, 2), 16);
  const g = parseInt(h.substring(2, 4), 16);
  const b = parseInt(h.substring(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

export default function CategoryButton({ name, icon, color, active = false, onClick, compact = false, fill = false }) {
  const IconComp = icon ? categoryIcons[icon] : null;
  const badgeColor = color || '#8e8e93';
  const monogram = String(name || '?').trim().slice(0, 1).toUpperCase();

  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={active}
      title={name}
      className={`flex items-center h-11 rounded-full border-none cursor-pointer touch-manipulation select-none overflow-hidden transition-colors duration-200 ease-out active:scale-[0.98] ${
        fill ? 'w-full min-w-0' : 'shrink-0'
      } ${
        active
          ? 'bg-white/[0.12] gap-2'
          : 'bg-white/[0.05] gap-2 [@media(hover:hover)]:hover:bg-white/[0.08]'
      }`}
      style={{
        maxWidth: fill ? undefined : compact ? (active ? 188 : 132) : undefined,
        padding: IconComp || compact || fill ? '0 14px 0 6px' : '0 18px',
        fontFamily: '"Public Sans", sans-serif',
        fontSize: '14px',
        fontWeight: active ? 600 : 500,
        letterSpacing: '-0.01em',
        color: active ? 'rgba(255, 255, 255, 0.95)' : 'rgba(255, 255, 255, 0.62)',
      }}
    >
      {(IconComp || compact || fill) && (
        <span
          className="flex items-center justify-center shrink-0 w-8 h-8 rounded-full"
          style={{ backgroundColor: hexToRgba(badgeColor, active ? 0.22 : 0.14) }}
        >
          {IconComp ? (
            <IconComp size={16} color={badgeColor} />
          ) : (
            <span style={{ fontSize: '13px', fontWeight: 700, color: badgeColor }}>{monogram}</span>
          )}
        </span>
      )}
      <span className="truncate min-w-0">{name}</span>
    </button>
  );
}
